import { render, staticRenderFns } from "./SnackComponent.vue?vue&type=template&id=d660ba7a&"
import script from "./SnackComponent.vue?vue&type=script&lang=js&"
export * from "./SnackComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports